/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function VisionBlurry(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'VisionBlurry',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('filter', {"id":"wf-svg-VisionBlurry-__a"},createElement('feGaussianBlur', {"in":"SourceGraphic","stdDeviation":".7"})),createElement('circle', {"opacity":".2","cx":"8","cy":"5","r":"4","fill":"#FF424D","filter":"url(#wf-svg-VisionBlurry-__a)"}),createElement('circle', {"opacity":".6","cx":"11.5","cy":"11","r":"4","fill":"#2FC862","filter":"url(#wf-svg-VisionBlurry-__a)"}),createElement('circle', {"opacity":".4","cx":"4.5","cy":"11","r":"4","fill":"#2496FF","filter":"url(#wf-svg-VisionBlurry-__a)"}))
}
